<template>
  <div class="home_about">
    <div class="gsjj">
      <p class="p1">产品案例</p>
      <div class="fg"></div>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="top">
          <img :src="item.imgUrl" alt="" />
        </div>
        <div class="bottom">
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemList from "../text/index";
export default {
  components: {},
  props: {},
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.list = itemList();
  },
};
</script>

<style lang="scss" scoped>
.home_about {
  background: linear-gradient(to bottom, #f4f5f8, #fbfbfc);
  // padding-top: 0.5rem;
  // background-color: #f10065;
}
.gsjj {
  width: 208px;
  height: 99px;
  // background-color: #073875;
  margin: 0 auto;
  padding-top: 83px;
  // margin-top: 100px;
  margin-bottom: 80px;
}
.fg {
  width: 165px;
  height: 5px;
  background: #0a41ff;
  border-radius: 0px 0px 0px 0px;
  margin: 47px 21px 0px 22px;
}
.p1 {
  width: 208px;
  height: 52px;
  font-size: 52px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #333333;
  background-color: rgba(255, 255, 255, 0);

  line-height: 93px;
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
}
.list {
  margin: 0 150px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  .item {
    width: 480px;
    height: 394px;
    background: #fff;
    margin-bottom: 53px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 40px;
    .top {
      width: 100%;
      img {
        width: 100%;
        height: 310px;
        // object-fit: cover;
      }
    }
    .bottom {
      margin-left: 40px;
      margin-top: 40px;
      .title {
        font-size: 24px;
        color: #333333;
      }
    }
  }
  .item:hover {
    box-shadow: 10px 10px 10px 10px #f4f5f8d8;
  }
}
</style>